<template>
  <div
    class="bg-center bg-no-repeat bg-cover text-white"
    style="height: 40px; background-color: #04aade"
  >
    <div class="flex items-center justify-center pt-2 font-bold">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>
